const SCRIPT_ID = 'CybersourceScript';

export { SCRIPT_ID };
